'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIPopoverHeader;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UIPopoverHeader(_ref) {
  var className = _ref.className,
      children = _ref.children;

  return _react2.default.createElement(
    'header',
    { className: (0, _reactUtils.classNames)('uiPopoverHeader', 'private-popover__header', className) },
    children
  );
}

UIPopoverHeader.propTypes = {
  children: _react.PropTypes.node,
  className: _react.PropTypes.string
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/tooltip/UIPopoverHeader.js
// module id = 261
// module chunks = 0 1